module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_j_normal.73a6aa17.png";